"use client";

import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ServiceCardGrid() {
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const {
    ref: gridRef,
    isVisible: gridVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const {
    ref: ctaRef,
    isVisible: ctaVisible
  } = useRevealOnScroll<HTMLDivElement>();
  const whiskeys = [{
    region: "INDUSTRIAL GRADE",
    name: "Phenolic Tags",
    age: "Durable Laminate",
    notes: ["UV STABLE", "CHEMICAL RESISTANT", "CUSTOM CUT"],
    price: "REQUEST",
    image: "https://evermarkindustrial.com/wp-content/uploads/2026/06/Phenolic_Legend_Plates_2-scaled.jpg?v=on622y2zflo",
    srcset: "https://evermarkindustrial.com/wp-content/uploads/2026/06/Phenolic_Legend_Plates_2-scaled.jpg?v=eqg16xvnufi",
    sizes: "https://evermarkindustrial.com/wp-content/uploads/2026/06/Phenolic_Legend_Plates_2-scaled.jpg?v=hk1v9uhmnea"
  }, {
    region: "SAFETY COMPLIANCE",
    name: "Arc Flash Labels",
    age: "NFPA 70E Rated",
    notes: ["HIGH CONTRAST", "DURABLE VINYL", "ANSI COMPLIANT"],
    price: "REQUEST",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1703715/img/arc_flash_label_safety.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1703715/img/arc_flash_label_safety.png",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1703715/img/arc_flash_label_safety.png"
  }, {
    region: "PRECISION MARKING",
    name: "Direct Part Marking",
    age: "Industrial DPM",
    notes: ["PERMANENT", "TRACEABLE", "HIGH SPEED"],
    price: "REQUEST",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1703715/img/engraving_dpm.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1703715/img/engraving_dpm.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1703715/img/engraving_dpm.png-wvc-sizes"
  }, {
    region: "METAL FABRICATION",
    name: "Laser Engraved Metal",
    age: "Stainless Steel",
    notes: ["CORROSION PROOF", "DEEP ETCH", "INDUSTRIAL"],
    price: "REQUEST",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1703715/img/engraving_metal.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1703715/img/engraving_metal.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1703715/img/engraving_metal.png-wvc-sizes"
  }, {
    region: "CUSTOM SOLUTIONS",
    name: "Custom Engraving",
    age: "Bespoke Design",
    notes: ["LOGO ETCHING", "SERIALIZATION", "VARIOUS SIZES"],
    price: "REQUEST",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1703715/img/engraving_custom.webp",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1703715/img/engraving_custom.webp-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1703715/img/engraving_custom.webp-wvc-sizes"
  }, {
    region: "ELECTRICAL",
    name: "Panel Labels",
    age: "UL 508A Standard",
    notes: ["LEGIBLE", "LONG LASTING", "MOUNT READY"],
    price: "REQUEST",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1703715/img/engraving_panel.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1703715/img/engraving_panel.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1703715/img/engraving_panel.png-wvc-sizes"
  }, {
    region: "PREMIUM STOCK",
    name: "Anodized Aluminum",
    age: "High Durability",
    notes: ["LIGHTWEIGHT", "SCRATCH RESISTANT", "MATTE FINISH"],
    price: "REQUEST",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1703715/img/engraving_aluminum.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1703715/img/engraving_aluminum.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1703715/img/engraving_aluminum.png-wvc-sizes"
  }, {
    region: "PREMIUM STOCK",
    name: "Brass Plates",
    age: "Architectural Grade",
    notes: ["CLASSIC LOOK", "WEATHER RESISTANT", "PREMIUM"],
    price: "REQUEST",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1703715/img/engraving_brass.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1703715/img/engraving_brass.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1703715/img/engraving_brass.png-wvc-sizes"
  }, {
    region: "DOCUMENTATION",
    name: "Submittal Packages",
    age: "Project Ready",
    notes: ["SPEC COMPLIANT", "FAST TURNAROUND", "CERTIFIED"],
    price: "REQUEST",
    image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1703715/img/engraving_submittal.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1703715/img/engraving_submittal.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1703715/img/engraving_submittal.png-wvc-sizes"
  }];
  return <section data-section-id="2747" id="service-card-grid" className="bg-background text-foreground py-24 md:py-32 lg:py-40 px-6 md:px-10 lg:px-16 overflow-hidden">
      <div className="max-w-7xl mx-auto">
        <div ref={headerRef} className={`text-center transition-all duration-1000 ease-out ${headerVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <p className="font-mono text-xs tracking-[0.3em] mb-8" style={{
          color: "var(--chart-1)"
        }}>
            CAPABILITIES / INDUSTRIAL ENGRAVING
          </p>
          <h2 className="font-default text-4xl md:text-5xl lg:text-6xl font-light leading-[1.1] max-w-3xl mx-auto" style={{
          color: "var(--foreground)"
        }}>
            Precision marking solutions for every industrial requirement.
          </h2>
        </div>

        <div ref={gridRef} className={`mt-20 md:mt-24 lg:mt-28 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 lg:gap-10 transition-all duration-1000 ease-out ${gridVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          {whiskeys.map((whiskey, i) => <Card key={i} data-index={i} className="group bg-card rounded-lg p-10 gap-0 transition-all duration-500 ease-out hover:-translate-y-2 hover:shadow-lg border border-border" style={{
          boxShadow: "var(--shadow-lg)"
        }}>
              <div className="relative overflow-hidden rounded-lg mb-8" style={{
            aspectRatio: "4 / 5",
            background: "radial-gradient(circle at center, hsl(216 40% 20% / 0.45) 0%, hsl(0 0% 0%) 70%)"
          }}>
                <div className="absolute inset-0 opacity-60" style={{
              background: "radial-gradient(circle at 50% 60%, hsl(45 68% 47% / 0.35) 0%, transparent 60%)"
            }} />
                <img src={whiskey.image} data-wvc-srcset={whiskey.srcset} data-wvc-sizes={whiskey.sizes} alt={whiskey.name} loading="lazy" decoding="async" className="relative w-full h-full object-contain transition-transform duration-700 ease-out group-hover:scale-[1.04]" />
              </div>

              <CardContent className="px-0">
                <p className="font-mono text-[10px] tracking-[0.25em] mb-4" style={{
              color: "var(--chart-1)"
            }}>
                  {whiskey.region}
                </p>
                <h3 className="font-default text-2xl md:text-[1.75rem] font-normal leading-tight mb-2" style={{
              color: "var(--foreground)"
            }}>
                  {whiskey.name}
                </h3>
                <p className="font-default italic text-base mb-6" style={{
              color: "var(--muted-foreground)"
            }}>
                  {whiskey.age}
                </p>

                <div className="h-px w-full mb-6" style={{
              background: "linear-gradient(to right, hsl(45 68% 47% / 0.6), transparent)"
            }} />

                <div className="flex flex-wrap gap-2 mb-8">
                  {whiskey.notes.map((note, j) => <span key={j} data-index={j} className="inline-flex items-center px-3 py-1.5 rounded-md border text-[10px] font-mono tracking-[0.2em]" style={{
                borderColor: "hsl(45 68% 47% / 0.35)",
                color: "var(--muted-foreground)"
              }}>
                      {note}
                    </span>)}
                </div>

                <div className="flex items-center justify-end">
                  <p className="font-sans text-sm font-medium tracking-wider" style={{
                color: "var(--chart-1)"
              }}>
                    STATUS — {whiskey.price}
                  </p>
                </div>
              </CardContent>
            </Card>)}
        </div>

        <div ref={ctaRef} className={`mt-20 md:mt-24 text-center transition-all duration-1000 ease-out ${ctaVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <Button asChild variant="link" className="group font-mono text-xs tracking-[0.3em] p-0 h-auto hover:no-underline" style={{
          color: "var(--chart-1)"
        }}>
            <Link to="/ContactPage">
              <span className="relative inline-block">
                CONTACT OUR TEAM
                <span className="absolute left-0 -bottom-1 h-px w-full origin-left scale-x-100 transition-transform duration-500 group-hover:scale-x-0" style={{
                backgroundColor: "var(--chart-1)"
              }} />
                <span className="absolute left-0 -bottom-1 h-px w-full origin-right scale-x-0 transition-transform duration-500 delay-150 group-hover:scale-x-100" style={{
                backgroundColor: "var(--chart-1)"
              }} />
              </span>
              <ArrowRight className="ml-2 size-3 transition-transform duration-300 group-hover:translate-x-1" />
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}